import {
  LightButton,
  MainCol,
  MainContainer,
  MainRow,
} from "components/common";
import {
  AnswerDiv,
  AnswerText,
  ContentContainer,
  FaqsWrapper,
  GitBookBtn,
  LeftDiv,
  QuestionDiv,
  QuestionText,
  Title,
} from "./element";
import { Image } from "react-bootstrap";
import { faq } from "assets";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { useState } from "react";
import { faqsData } from "./data";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { SiGitbook } from "react-icons/si";
function FaqsCom() {
  const [isAnswerVisible, setIsAnswerVisible] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState();

  const handleMinusToggle = (index) => {
    setIsAnswerVisible(false);
    setSelectedIndex(index);
  };

  const handlePlusToggle = (index) => {
    setIsAnswerVisible(true);
    setSelectedIndex(index);
  };

  const handleButtonClick = () => {
    window.open("https://www.gitbook.com", "_blank");
  };

  return (
    <FaqsWrapper id="faq">
      <MainContainer>
        <AnimationOnScroll animateIn="animate__bounceIn">
          <Title>Frequently Asked Questions</Title>
        </AnimationOnScroll>
        <ContentContainer>
          <MainRow>
            <MainCol lg={8}>
              <AnimationOnScroll animateIn="animate__fadeInLeft">
                <LeftDiv>
                  {faqsData?.map((item, index) => (
                    <div className="main-dev" key={item.id}>
                      <QuestionDiv>
                        <QuestionText>Q: {item.question}</QuestionText>
                        {selectedIndex === index && isAnswerVisible ? (
                          <AiOutlineMinus
                            className="plus-icon"
                            onClick={() => handleMinusToggle(index)}
                          />
                        ) : (
                          <AiOutlinePlus
                            className="plus-icon"
                            onClick={() => handlePlusToggle(index)}
                          />
                        )}
                      </QuestionDiv>

                      {selectedIndex === index && isAnswerVisible && (
                        <AnswerDiv>
                          <AnswerText>{item.answer}</AnswerText>
                        </AnswerDiv>
                      )}
                    </div>
                  ))}

                  <div className="btn-div">
                    <LightButton
                      btnText="Gitbook"
                      bookIcon={true}
                      navigate="gitbook"
                    />
                  </div>
                </LeftDiv>
              </AnimationOnScroll>
            </MainCol>
            <MainCol lg={4}>
              <AnimationOnScroll animateIn="animate__fadeInRight">
                <Image src={faq} fluid />
              </AnimationOnScroll>
            </MainCol>
          </MainRow>
        </ContentContainer>
      </MainContainer>
    </FaqsWrapper>
  );
}

export default FaqsCom;
